import { compose, withProps } from "recompose";
import yup from "yup";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { parse } from "query-string";
import { withRouter } from "react-router-dom";
import { fetchApi } from "core/api/hoc";
import { createLoadingSelector } from "core/helpers";
import { withActions } from "core/redux/hoc";
import * as insidersApi from "modules/insiders/api";
import * as bookingApi from "modules/booking/api";
import * as model from "modules/booking/model";
import * as hoc from "modules/user/auth/hoc";
import { isOnboardedCandidate } from "modules/user/auth/model";
import * as insidersSelectors from "modules/insiders/selectors";
import * as bookingSelectors from "modules/booking/selectors";
import View from "./View";

export default compose(
  hoc.authorized(isOnboardedCandidate),
  withRouter,
  connect(
    createStructuredSelector({
      booking: bookingSelectors.fetchBookingDetail,
      rescheduleApi: bookingSelectors.rescheduleBookingApi,
      isLoading: createLoadingSelector(
        insidersSelectors.getAvailableTimeApi,
        bookingSelectors.getBookingDetailApi
      )
    })
  ),
  fetchApi(bookingApi.getBookingDetail, ({ match, location }) => {
    const { booking_id } = parse(location.search);
    return {
      payload: {
        id: booking_id
      },
      sync: true,
      selector: bookingSelectors.getBookingDetailApi
    };
  }),
  fetchApi(insidersApi.getAvailableTime, ({ booking }) => ({
    payload: {
      id: booking.insider.id
    },
    key: "slots",
    selector: insidersSelectors.getAvailableTimeApi
  })),
  withProps(({ location }) => ({
    initialValues: {},
    validationSchema: yup.object().shape({
      slot: yup.string().required("This field is required")
    }),
    date: model.getDate(location)
  })),
  withActions({
    onSubmit: ({ location }) => ({ slot }) => {
      const { booking_id } = parse(location.search);

      return bookingApi.rescheduleBooking.request({
        bookingId: booking_id,
        timeSlotId: slot
      });
    }
  })
)(View);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/Reschedule/Provider.js